export const PRECHAT_CAPTURE = {
    REPLY: 'prechatcapture:reply',
};
